var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgT1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 690,
    viewBox: "0 0 678 690",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.988 356.355L623.646 260.29L295.989 6L308.331 102.065L635.988 356.355Z",
    fill: "url(#paint0_linear_162_1064)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M635.988 356.355L623.646 260.29L295.989 6L308.331 102.065L635.988 356.355Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4093 429.724L42.0169 333.362L295.95 6L308.336 102.37L54.4093 429.724Z",
    fill: "url(#paint1_linear_162_1064)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4093 429.724L42.0169 333.362L295.95 6L308.336 102.37L54.4093 429.724Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M635.805 356.964L307.615 102.232L54.1818 429.123L382.372 683.856L635.805 356.964Z",
    fill: "url(#paint2_linear_162_1064)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_1064",
    x1: 457.599,
    y1: 115.914,
    x2: 486.071,
    y2: 345.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EE3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A655A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3FCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_162_1064",
    x1: 66.7004,
    y1: 231.317,
    x2: 367.591,
    y2: 192.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7F4B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_162_1064",
    x1: 318.453,
    y1: 186.494,
    x2: 377.747,
    y2: 664.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A655A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/t1.2691025310288cd27dd96ac600a5d7c7.svg";
export { ForwardRef as ReactComponent };